import axios from 'axios'
import {AzSearchUrlBuilder} from '@azinformatica/loki'

class LicitacaoApiClient {

    async buscaPaginadaDeComissoes(filtros, paginacao) {
        const url = AzSearchUrlBuilder.build('api/configuracoes/comissoesapuracao/paginado', filtros, paginacao)
        return await axios.get(url)
    }
}

export default new LicitacaoApiClient()
